import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Alert, Spinner } from "react-bootstrap";
import api from "@/api/api.js";
import i18n from "@/i18n.js";

/**
 * Una cuenta = un usuario = una empresa: aquí ya no hay listado ni botón de
 * crear. La pantalla resuelve cuál es la empresa del usuario y muestra su ficha;
 * si todavía no tiene, lleva al alta. El listado anterior sólo tenía sentido
 * cuando una cuenta podía registrar varias.
 */
const MyCompanies = () => {
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api
      .get("/companies", { params: { itemsPerPage: 1 } })
      .then(({ data }) => {
        if (cancelled) return;
        setCompany(data["hydra:member"]?.[0] ?? null);
      })
      .catch(() => {
        if (!cancelled) setError(i18n.t("ui.accountLoadError"));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return (
      <div className="col">
        <div className="card">
          <div className="card-body text-center py-5">
            <Spinner animation="border" />
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="col">
        <Alert variant="danger">{error}</Alert>
      </div>
    );
  }

  return company ? (
    <Navigate to={`/companies/${company.id}`} replace />
  ) : (
    <Navigate to="/onboarding/company" replace />
  );
};

export default MyCompanies;
